import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { MapPin, Search } from "lucide-react";

const SearchBar = () => {
  const [query, setQuery] = useState("");
  const [location, setLocation] = useState("");
  const navigate = useNavigate();

  const handleSearch = (e) => {
    e.preventDefault();
    navigate(`/search?q=${encodeURIComponent(query)}&location=${encodeURIComponent(location)}`);
  };

  return (
    <form onSubmit={handleSearch} className="w-full max-w-4xl mx-auto">
      <div className="flex flex-col md:flex-row gap-4 glass-card p-4">
        <div className="flex-1 flex items-center gap-2">
          <Search className="w-5 h-5 text-[#A1A1AA]" />
          <input
            type="text"
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            placeholder="Search breed, species, or keyword..."
            className="bg-transparent border-none text-[#EDEDED] placeholder:text-[#A1A1AA]/50 w-full focus:outline-none"
            data-testid="search-input"
          />
        </div>
        <div className="flex items-center gap-2 md:border-l md:border-white/10 md:pl-4">
          <MapPin className="w-5 h-5 text-[#A1A1AA]" />
          <input
            type="text"
            value={location}
            onChange={(e) => setLocation(e.target.value)}
            placeholder="City, State, or ZIP"
            className="bg-transparent border-none text-[#EDEDED] placeholder:text-[#A1A1AA]/50 w-full md:w-48 focus:outline-none"
            data-testid="location-input"
          />
        </div>
        <button type="submit" className="btn-gold text-sm px-6 py-3" data-testid="search-btn">
          Search
        </button>
      </div>
    </form>
  );
};

export default SearchBar;
